// this file was prevaled
module.exports = {
  "type": {
    "baseFontSize": "16px",
    "sizes": {
      "xs": "14px",
      "sm": "20px",
      "baseline": "16px",
      "md": "22px",
      "lg": "26px",
      "xl": "30px"
    },
    "size": {
      "brandMarketing": {
        "xs": "14px",
        "sm": "20px",
        "baseline": "16px",
        "md": "60px",
        "lg": "80px",
        "xl": "120px"
      },
      "desktop": {
        "xs": "14px",
        "sm": "20px",
        "baseline": "16px",
        "md": "24px",
        "lg": "28px",
        "xl": "36px"
      }
    },
    "fontFamily": {
      "base": "\"Helvetica Neue\", Helvetica, Arial, sans-serif",
      "brand": "\"Nike TG\", \"Helvetica Neue\", Helvetica, Arial, sans-serif",
      "marketing": "\"Nike Futura\", \"Helvetica Neue\", Helvetica, Arial, sans-serif"
    },
    "lineHeight": {
      "mobile": {
        "14": 1.7142857142857142,
        "16": 1.75,
        "20": 1.5,
        "22": 1.4545454545454546,
        "24": 1.5,
        "26": 1.3076923076923077,
        "28": 1.4285714285714286,
        "30": 1.3333333333333333,
        "36": 1.3333333333333333,
        "40": 0.9,
        "60": 0.8333333333333334,
        "80": 0.875,
        "120": 0.8333333333333334
      },
      "tablet": {
        "20": 1.6,
        "60": 0.9333333333333333
      }
    },
    "fontWeight": {
      "regular": 400,
      "medium": 500
    }
  },
  "colors": {
    "colorPalette": {
      "black": {
        "base": "#111111",
        "light": "rgba(0, 0, 0, 0.75)",
        "dark": "#0D0D0D"
      },
      "white": {
        "base": "#ffffff",
        "light": "rgba(255, 255, 255, 0.75)",
        "dark": "#BFBFBF"
      },
      "grey": {
        "base": "#757575",
        "light": "rgba(117, 117, 117, 0.75)",
        "dark": "#585858"
      },
      "orange": {
        "base": "#FA5400",
        "light": "rgba(250, 84, 0, 0.75)",
        "dark": "#BC3F00"
      },
      "red": {
        "base": "#d43f21"
      },
      "green": {
        "base": "#128a09"
      }
    },
    "brand": {
      "black": "#111111",
      "white": "#ffffff",
      "grey": "#757575",
      "orange": "#FA5400",
      "red": "#d43f21",
      "green": "#128a09",
      "inactiveGrey": "#CCCCCC",
      "borderGrey": "#E5E5E5",
      "primaryGrey": "#F5F5F5",
      "secondaryGrey": "#FAFAFA",
      "accent": "#FA5400",
      "error": "#d43f21",
      "success": "#128a09"
    }
  },
  "breakpoints": {
    "mobile": 0,
    "tablet": 600,
    "desktop": 960,
    "largeDesktop": 1440,
    "extraLargeDesktop": 1920
  },
  "mediaQueries": {
    "mobile": "only screen and (min-width: 0px)",
    "sm": "(max-width: 599px)",
    "md": "(min-width: 600px) and (max-width: 959px)",
    "lg": "(min-width: 960px) and (max-width: 1439px)",
    "xl": "(min-width: 1440px) and (max-width: 1919px)",
    "xxl": "(min-width: 1920px)",
    "tablet": "only screen and (min-width: 600px)",
    "desktop": "only screen and (min-width: 960px)",
    "largeDesktop": "only screen and (min-width: 1440px)",
    "extraLargeDesktop": "only screen and (min-width: 1920px)"
  },
  "zIndex": {
    "z0": 0,
    "z1": 1,
    "z2": 2,
    "z3": 3,
    "z4": 4,
    "z5": 5,
    "z6": 6,
    "z7": 7,
    "z8": 8,
    "z9": 9,
    "z10": 10,
    "low": 0,
    "mid": 5,
    "high": 10
  },
  "scaleIncrement": 4,
  "spacing": {
    "baseline": 16,
    "padding": "4px",
    "scale": [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80, 84, 88, 92, 96, 100, 104, 108, 112, 116]
  },
  "layout": {
    "gutter": 16,
    "maxWidth": 1808,
    "grid": {
      "columnCount": 12,
      "columnWidth": {
        "1": "8.333333333333334%",
        "2": "16.666666666666668%",
        "3": "25%",
        "4": "33.333333333333336%",
        "5": "41.66666666666667%",
        "6": "50%",
        "7": "58.333333333333336%",
        "8": "66.66666666666667%",
        "9": "75%",
        "10": "83.33333333333334%",
        "11": "91.66666666666667%",
        "12": "100%"
      }
    }
  },
  "transition": {
    "default": {
      "duration": "250ms",
      "timing": "cubic-bezier(0.77, 0, 0.175, 1)",
      "transition": "all 250ms cubic-bezier(0.77, 0, 0.175, 1)"
    }
  },
  "borderRadius": 24
};